import { render, staticRenderFns } from "./SurveyDetailView.vue?vue&type=template&id=68a00b9e"
import script from "./SurveyDetailView.vue?vue&type=script&lang=js"
export * from "./SurveyDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports